/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Supportsuffix2Inputs */

const zh_pricing_faq5a_supportsuffix2 = /** @type {(inputs: Pricing_Faq5a_Supportsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取帮助。`)
};

const en_pricing_faq5a_supportsuffix2 = /** @type {(inputs: Pricing_Faq5a_Supportsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` for assistance.`)
};

const es_pricing_faq5a_supportsuffix2 = /** @type {(inputs: Pricing_Faq5a_Supportsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` para obtener asistencia.`)
};

/**
* | output |
* | --- |
* | "for assistance." |
*
* @param {Pricing_Faq5a_Supportsuffix2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_supportsuffix2 = /** @type {((inputs?: Pricing_Faq5a_Supportsuffix2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Supportsuffix2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_supportsuffix2(inputs)
	if (locale === "en") return en_pricing_faq5a_supportsuffix2(inputs)
	return es_pricing_faq5a_supportsuffix2(inputs)
});
export { pricing_faq5a_supportsuffix2 as "pricing_faq5A_supportSuffix" }